<template>
  <!----------------------------------------------------------------------------->
  <div class="endTimeBody">
    <div class="entry" @click="cb">
      <div class="txt">直播入口</div>
      <div class="img">
        <img src="../../static/close-1.png" v-show="!show" />
        <img src="../../static/open-1.png" v-show="show" />
      </div>
    </div>
    <div class="testshow" :class="[show ? 'active' : '']">
      <div class="qrCode" v-for="(item, index) in itemTitle" :key="index">
        <div class="img"><img :src="item.url" alt="" /></div>
        <div class="titleTxt">{{ item.title }}</div>
      </div>
    </div>
  </div>
  <!----------------------------------------------------------------------------->
</template>

<script>
export default {
  data() {
    return {
      show: true,
      itemTitle: [
        {
          title: "视频直播",
          url: require("../../static/videoLive.jpg"),
        },
        {
          title: "图片直播",
          url: require("../../static/pictureLive.jpg"),
        },
      ],
    };
  },
  methods: {
    cb() {
      this.show = !this.show;
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.endTimeBody {
  display: flex;
  width: fit-content;
  border-radius: 10px 0px 0px 10px;
  background: #fdd72a;
  height: 220px;
  .entry {
    width: 72px;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
    background: #fdd72a;
    border-top-left-radius: 20px 20px;
    border-bottom-left-radius: 20px 20px;
    .txt {
      word-wrap: break-word;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      padding: 35px 23px 0px 23px;
    }
    .img {
      width: 18px;
      height: 18px;
      padding-top: 24px;
      padding-bottom: 34px;
      padding-left: 26px;
      padding-right: 26px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .testshow {
    width: 250px;
    background: #fdd72a;
    height: 100%;

    // 浏览器兼容
    transition: width 1s;
    -moz-transition: width 1s; /* Firefox 4 */
    -webkit-transition: width 1s; /* Safari and Chrome */
    -o-transition: width 1s; /* Opera */
    display: grid;
    grid-template-columns: repeat(2, 120px);
    align-items: center;

  }
}
//缓慢的滑出
.active {
  width: 0px !important;
}
.qrCode {
  height: fit-content;
  background-color: white;
   width: 110px;
  .img {
    width: 90px;
    display: block;
    padding: 5px 5px;
    margin: 0 auto;
    img {
      width: 90px;
      display: block;
    }
  }
  .titleTxt {
    font-size: 16px;
    text-align: center;
    padding-top: 5px;
    background-color: #fdd72a;
    &:hover {
      color: #006fb8;
      border-radius: 4px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }
}
</style>
